import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2, ArrowDown } from 'lucide-react';
import { motion } from 'framer-motion';
export function UrgencyClose() {
  return <section id="comprar" className="bg-dark-green py-20 md:py-28 px-6 md:px-12 lg:px-24 text-white relative overflow-hidden" data-id="element-261">
      {/* Background accents */}
      <div className="absolute inset-0" data-id="element-262">
        <div className="absolute -top-20 -left-20 w-80 h-80 bg-gold/5 rounded-full blur-3xl" data-id="element-263" />
        <div className="absolute -bottom-20 -right-20 w-80 h-80 bg-sage/5 rounded-full blur-3xl" data-id="element-264" />
      </div>

      <div className="max-w-2xl mx-auto relative z-10" data-id="element-265">
        {/* Header */}
        <FadeIn data-id="element-266">
          <div className="text-center mb-12" data-id="element-267">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold leading-tight mb-3" data-id="element-268">
              Una última cosa antes de irte:
            </h2>
            <div className="w-12 h-1 bg-gold/40 mx-auto" data-id="element-269" />
          </div>
        </FadeIn>

        {/* Persuasion copy — compact card */}
        <FadeIn delay={0.15} data-id="element-270">
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 md:p-10 mb-10 space-y-5 text-center" data-id="element-271">
            <p className="text-lg md:text-xl leading-relaxed text-white/85" data-id="element-272">
              Cada mañana que esperas es otra mañana de rigidez. Otra mañana de
              crujidos. Otro día alimentando el fuego que nadie ve.
            </p>

            <div className="flex justify-center" data-id="element-273">
              <div className="w-8 h-px bg-gold/30" data-id="element-274" />
            </div>

            <p className="text-lg md:text-xl leading-relaxed text-white/85" data-id="element-275">
              El protocolo cuesta menos que un café en Starbucks. Los
              ingredientes los encuentras en cualquier mercado. Las
              preparaciones más largas toman 20 minutos.
            </p>

            <div className="flex justify-center" data-id="element-276">
              <div className="w-8 h-px bg-gold/30" data-id="element-277" />
            </div>

            <p className="text-xl md:text-2xl font-bold text-gold" data-id="element-278">
              No hay ninguna razón lógica para no probarlo.
            </p>
          </div>
        </FadeIn>

        {/* Key question */}
        <FadeIn delay={0.3} data-id="element-279">
          <div className="text-center mb-8" data-id="element-280">
            <p className="text-2xl md:text-3xl font-serif font-bold leading-snug" data-id="element-281">
              La única pregunta real es:{' '}
              <span className="text-gold" data-id="element-282">
                ¿Cuántas mañanas más vas a esperar?
              </span>
            </p>
          </div>
        </FadeIn>

        {/* Arrow */}
        <FadeIn delay={0.4} data-id="element-283">
          <motion.div animate={{
          y: [0, 6, 0]
        }} transition={{
          repeat: Infinity,
          duration: 1.5,
          ease: 'easeInOut'
        }} className="flex justify-center mb-6" data-id="element-284">
            <ArrowDown className="text-gold/50" size={24} data-id="element-285" />
          </motion.div>
        </FadeIn>

        {/* CTA */}
        <FadeIn delay={0.45} data-id="element-286">
          <div className="text-center mb-10" data-id="element-287">
            <button type="button" onClick={(e: React.MouseEvent) => {
            e.preventDefault();
            e.stopPropagation();
            const HOTMART_URL = 'https://pay.hotmart.com/U105224808G?checkoutMode=10';
            // Try fbq on current window
            const w = window as any;
            let fired = false;
            if (typeof w.fbq === 'function') {
              w.fbq('track', 'InitiateCheckout');
              fired = true;
            }
            // Try fbq on parent window (if inside iframe)
            try {
              const p = window.parent as any;
              if (p && p !== window && typeof p.fbq === 'function') {
                p.fbq('track', 'InitiateCheckout');
                fired = true;
              }
            } catch {
              // cross-origin, ignore
            }
            // Fallback: sendBeacon to Meta directly
            if (!fired && navigator.sendBeacon) {
              navigator.sendBeacon('https://www.facebook.com/tr/?id=1146490364187509&ev=InitiateCheckout&noscript=1');
            }
            console.log('[MetaPixel] InitiateCheckout fired:', fired);
            setTimeout(() => {
              window.location.assign(HOTMART_URL);
            }, 800);
          }} className="w-full md:w-auto bg-[#FF4500] hover:bg-[#e63e00] text-white text-lg md:text-2xl font-bold py-5 px-10 rounded-full shadow-xl transform transition-all duration-300 hover:scale-105 hover:shadow-2xl inline-block no-underline text-center cursor-pointer" data-id="element-288">
              👆 Sí, quiero mi protocolo por solo $7
            </button>
          </div>
        </FadeIn>

        {/* Trust badges — single row */}
        <FadeIn delay={0.55} data-id="element-289">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-3 text-sm text-white/70" data-id="element-290">
            {['Acceso inmediato', 'Garantía de 15 días', 'Pago 100% seguro', 'PDF en tu correo'].map(item => <div key={item} className="flex items-center gap-1.5" data-id="element-291">
                <CheckCircle2 size={16} className="text-sage" data-id="element-292" />
                <span data-id="element-293">{item}</span>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}